import React, { useMemo } from 'react';
import { Select } from 'tea-component';
import { metricsList } from './config';
import { useIntl } from 'umi';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function MetricsSetSelect({
  value,
  setValue,
}: {
  value: string;
  setValue: (value: string) => void;
}) {
  const { formatMessage } = useIntl();

  const options = useMemo(() => {
    return [...metricsList, 'Customized'].map((item) => {
      return { text: formatMessage({ id: item }), value: item };
    });
  }, [formatMessage]);

  return (
    <Select
      className="dbo-metrics-select-set"
      size="m"
      appearance="button"
      value={value}
      button={
        <div className="select-button">
          <span className="select-button-text">
            {formatMessage({ id: 'Metrics Set' })}
          </span>
          <span>{formatMessage({ id: value })}</span>
        </div>
      }
      onChange={(value) => {
        setValue(value);
        buriedBtnPoint('ClickOneMetricsSet', value);
      }}
      options={options}
      matchButtonWidth
      listHeight={236}
    />
  );
}
